import blogContent from "./blog-content.json";

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  coverImage: string;
  category: string;
  tags: string[];
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export const defaultBlogPosts: BlogPost[] = [
  {
    id: "post-1",
    slug: "when-everything-feels-too-much-finding-calm",
    title: "When Everything Feels Too Much: Finding Calm Through Personalised Coaching",
    excerpt: "Feeling overwhelmed is more common than you think. Discover how personalised coaching sessions can help you find calm and clarity when life feels unmanageable.",
    content: blogContent.post1,
    coverImage: "https://readdy.ai/api/search-image?query=A%20serene%20minimalist%20scene%20with%20soft%20warm%20natural%20light%20falling%20on%20a%20simple%20wooden%20desk%20with%20a%20cup%20of%20herbal%20tea%20and%20a%20small%20notebook%2C%20gentle%20shadows%2C%20calm%20and%20peaceful%20atmosphere%2C%20editorial%20photography%20with%20soft%20focus%20and%20warm%20neutral%20tones&width=1200&height=630&seq=blog-overwhelm-01&orientation=landscape",
    category: "Emotional Wellbeing",
    tags: ["overwhelm", "calm", "personalised coaching", "emotional support"],
    published: true,
    createdAt: "2026-06-15T00:00:00.000Z",
    updatedAt: "2026-06-15T00:00:00.000Z",
  },
  {
    id: "post-2",
    slug: "recovering-from-burnout-practical-mindfulness",
    title: "Recovering from Burnout: Practical Mindfulness and Emotional Recovery Strategies",
    excerpt: "Burnout can leave you feeling depleted and disconnected. Learn practical mindfulness techniques and recovery strategies to restore your energy and find your way back to yourself.",
    content: blogContent.post2,
    coverImage: "https://readdy.ai/api/search-image?query=A%20quiet%20morning%20scene%20with%20soft%20diffused%20sunlight%20streaming%20through%20sheer%20curtains%20onto%20a%20cozy%20armchair%20with%20a%20soft%20throw%20blanket%2C%20a%20steaming%20cup%20of%20tea%20on%20a%20small%20side%20table%2C%20peaceful%20and%20restorative%20atmosphere%2C%20warm%20neutral%20tones%20with%20gentle%20shadows&width=1200&height=630&seq=blog-burnout-02&orientation=landscape",
    category: "Stress & Recovery",
    tags: ["burnout", "mindfulness", "emotional recovery", "stress management"],
    published: true,
    createdAt: "2026-06-18T00:00:00.000Z",
    updatedAt: "2026-06-18T00:00:00.000Z",
  },
  {
    id: "post-3",
    slug: "you-dont-have-to-do-this-alone-compassionate-support",
    title: "You Don't Have to Do This Alone: Finding Safe, Compassionate Support",
    excerpt: "Feeling isolated can make everything harder. Discover how compassionate, non-judgemental coaching creates a safe space where you can be truly heard and supported.",
    content: blogContent.post3,
    coverImage: "https://readdy.ai/api/search-image?query=Two%20comfortable%20armchairs%20facing%20each%20other%20in%20a%20warm%20inviting%20room%20with%20soft%20natural%20light%2C%20a%20small%20plant%20on%20a%20side%20table%2C%20gentle%20and%20safe%20atmosphere%2C%20warm%20neutral%20interior%20with%20textured%20fabrics%20and%20minimalist%20decor&width=1200&height=630&seq=blog-isolated-03&orientation=landscape",
    category: "Emotional Wellbeing",
    tags: ["isolation", "compassionate support", "connection", "safe space"],
    published: true,
    createdAt: "2026-06-22T00:00:00.000Z",
    updatedAt: "2026-06-22T00:00:00.000Z",
  },
  {
    id: "post-4",
    slug: "rebuilding-confidence-small-steps-stronger-you",
    title: "Rebuilding Confidence: Small Steps Toward a Stronger You",
    excerpt: "Low confidence can hold you back in ways you might not even notice. Explore confidence-building action plans that help you rediscover your strength, one small step at a time.",
    content: blogContent.post4,
    coverImage: "https://readdy.ai/api/search-image?query=A%20person%20standing%20at%20the%20start%20of%20a%20gentle%20winding%20path%20through%20a%20peaceful%20garden%20with%20soft%20morning%20light%2C%20lush%20greenery%2C%20hopeful%20and%20encouraging%20atmosphere%2C%20warm%20natural%20tones%20with%20a%20sense%20of%20possibility&width=1200&height=630&seq=blog-confidence-04&orientation=landscape",
    category: "Personal Growth",
    tags: ["confidence", "encouragement", "action plans", "self-trust"],
    published: true,
    createdAt: "2026-06-25T00:00:00.000Z",
    updatedAt: "2026-06-25T00:00:00.000Z",
  },
  {
    id: "post-5",
    slug: "finding-your-direction-structured-coaching-next-steps",
    title: "Finding Your Direction: Structured Coaching for Clear Next Steps",
    excerpt: "When you feel lost or unsure about your path forward, structured coaching with achievable goals can provide the clarity and direction you've been searching for.",
    content: blogContent.post5,
    coverImage: "https://readdy.ai/api/search-image?query=A%20simple%20compass%20resting%20on%20an%20open%20notebook%20on%20a%20wooden%20table%20with%20soft%20natural%20light%2C%20a%20warm%20cup%20of%20coffee%20nearby%2C%20peaceful%20and%20contemplative%20atmosphere%2C%20warm%20neutral%20tones%20with%20gentle%20shadows&width=1200&height=630&seq=blog-direction-05&orientation=landscape",
    category: "Personal Growth",
    tags: ["direction", "structured coaching", "goals", "clarity"],
    published: true,
    createdAt: "2026-06-28T00:00:00.000Z",
    updatedAt: "2026-06-28T00:00:00.000Z",
  },
  {
    id: "post-6",
    slug: "making-yourself-a-priority-accountability-self-care",
    title: "Making Yourself a Priority: Accountability and Tailored Self-Care Support",
    excerpt: "Struggling to prioritise your own wellbeing? Regular check-ins and tailored accountability support can help you build self-care habits that actually stick.",
    content: blogContent.post6,
    coverImage: "https://readdy.ai/api/search-image?query=A%20peaceful%20self-care%20moment%20with%20a%20woman%20sitting%20comfortably%20in%20a%20cozy%20nook%20by%20a%20window%2C%20soft%20morning%20light%2C%20journal%20and%20pen%20in%20hand%2C%20herbal%20tea%20on%20a%20small%20table%2C%20warm%20and%20nurturing%20atmosphere%2C%20soft%20textures%20and%20neutral%20tones&width=1200&height=630&seq=blog-selfcare-06&orientation=landscape",
    category: "Self-Care & Accountability",
    tags: ["self-care", "accountability", "check-ins", "tailored support"],
    published: true,
    createdAt: "2026-07-02T00:00:00.000Z",
    updatedAt: "2026-07-02T00:00:00.000Z",
  },
];